import { useState } from "react";

type Props = {
  src: string;
  alt: string;
  className?: string;
  label?: string;
};

export const SafeImage = ({ src, alt, className, label }: Props) => {
  const [error, setError] = useState(false);
  if (error) {
    return (
      <div className={`placeholder-stripes flex items-center justify-center bg-[#0A0A0A] ${className ?? ""}`} role="img" aria-label={alt}>
        <span className="px-4 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-krono">
          {label ?? "Arte em geração"}
        </span>
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setError(true)} />;
};
